import React from 'react';
import ReactDOM from 'react-dom';

// Import App component
import App from './App';

// Import reportWebVitals function for reporting web vitals
import reportWebVitals from './reportWebVitals';

// Import stylesheet
import './index.css';

// Render App component to the root element
ReactDOM.render(<App />, document.getElementById('root'));

// Report web vitals
reportWebVitals();